module.exports = __webpack_public_path__ + "assets/img/14.7cf2d4ad.png";